export default __webpack_public_path__ + "static/media/progressive.eb3429ed.png";